export default __webpack_public_path__ + "static/media/arrowUp.d183d3f6.svg";